import { styled } from 'styled-components';

export const OtpInputWrapper = styled.div`
  max-width: ${({ $width }) => ($width ? $width : '385px')};
  margin: 0 auto 20px;

  .otp-fields {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 20px;

    @media (min-width: 576px) {
      gap: 20px;
    }
  }

  input {
    width: 100%;
    max-width: ${({ $inputWidth }) => ($inputWidth ? $inputWidth : '100px')};
    height: 60px;
    border: 1px solid transparent;
    background: ${({ $inputBg }) => ($inputBg ? $inputBg : 'var(--white)')};
    border-radius: 60px;
    padding: 10px;
    font-size: 28px;
    line-height: 32px;
    box-sizing: border-box;
    outline: none;
    text-align: center;
    border: 1px solid #efefef;

    @media (max-width: 576px) {
      height: 50px;
      padding: 10px 10px 5px;
      font-size: 20px;
      line-height: 24px;
    }

    &::placeholder {
      font-size: 35px;
      line-height: 20px;
      color: #777777;
    }
    &:focus,
    &:not(:placeholder-shown) {
      border-color: #1edce3; /* Change border color when input has value */
    }
  }

  input:focus::placeholder {
    color: transparent;
  }
  .error {
    border: 1px solid red;
    transition: border var(--animation-speed) ease-in-out;
  }

  .timer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;

    .resend-code {
      color: var(--primary);
      cursor: pointer;

      &.disabled {
        color: #777777;
        cursor: not-allowed;
      }
    }
  }
`;
